import {GCPortalkarteClass} from "./class_portalkarte";
import {GCPortalkarteStyle} from "./class_portalkarte_style";
import {GCPortalkarteEditbarClass} from "./class_portalkarte_editbar";

export class GCPortalkarteEditClass extends GCPortalkarteClass {

    /**
     * Style des Trackinglayers
     * @private
     */
    private trackinglayer_style:GCPortalkarteStyle;


    private ZoomToExtentCtrl:any = null;


    /**
     * HTML-ID des Elementes, welches den GeoJSON des TrackingLayers aufnehmen soll
     * @private
     */
    private geoJsonTarget: string;

    /**
     * Flag, ob die Karte editierbar ist
     * @private
     */
    private is_editable: boolean;

    /**
     * Flag, ob die Metadaten editierbar ist
     * @private
     */
    private is_edit_meta: boolean;

    /**
     * Referenz auf das EditBar-Objekt (im MenuBar-Objekt enthalten)
     * @private
     */
    private editbar: any;

    /**
     * Maximale Anzahl der erlaubten Features
     * @private
     */
    private maxFeatures: number;

    /**
     * KONSTRUKTOR
     * @param {string} idname
     * @param {object} _options
     */
    public constructor(idname: string, _options: object) {

        super(idname, _options);
        this.trackingLayer = null;
        this.geoJsonTarget = '';
        this.is_editable = true;
        this.is_edit_meta = true;
        this.editbar = null;
        this.maxFeatures = 0;

        this.trackinglayer_style = new GCPortalkarteStyle();

        this.callAs = 'edit';
    }

    /**
     * Initialisiert das Kartenobjekt speziell als Eingabe-Element
     * @param {any} _options Objekt mit Optionen
     * @param {any} olContainer Array mit Feature-Objekten, die auf dem Feature-Layer eingezeichnet werden
     */
    public initControlMap(_options: any, olContainer?: any[]) {
        if (typeof _options === "undefined") {
            _options = {};
        }

        if (typeof olContainer === "undefined" || !olContainer) {
            olContainer = [];
        }

        let options = this.defaultValues;
        this.jquery.extend(options, _options);

        // Optionen übernehmen
        this.setDebug(false)
            .setMaxZoom(options.maxZoom)
            .setMaxZoomSteps(options.maxZoomSteps)
            .setExtentPaddingFactor(options.extentPaddingFactor)
            .addBasicBackgroundLayer(options.mapBackground) // Hintergrund-Karte setzen
            .initFeatureLayer() // Feature-Layer erzeugen
            .initDirectFeatureLayer() // DirectFeature-Layer erzeugen
            .initOverlayLayer() // Layer für Infobox erzeugen
            .onFeatureClick(null);

        // ggf. Features hinzufügen
        for (let i = 0; i < olContainer.length; i++) {
            this.addFeature(olContainer[i]);
        }
        // Beispiel für eine einfaches Feature
        // this.addSimpleFeature(this.ol.proj.fromLonLat([11,51]),'EPSG:3857','testpunkt');

        // HTML-Container ermitteln und konfigurieren
        let html = this.jquery('#' + this.getTargetId());
        if (options.mapDynamic) {
            html.prop('style', 'min-width:' + options.mapWidth + 'px; height:' + options.mapHeight + 'px');
            html.addClass('w-100');
        } else {
            html.prop('style', 'width:' + options.mapWidth + 'px; height:' + options.mapHeight + 'px');
        }

        // Geerbte Initialisierung der Portalkarte ausführen
        this.initMap(options.mapStartpoint);
        return this;
    }

    /**
     * Erzeugen einer einfachen Kartenausgabe
     * @param {number} startZoom
     */
    public renderControlMap(startZoom: number) {
        this.renderMap(startZoom, false);

        // Bearbeitungslayer immer aktiv
        if (this.directFeatureLayer) {
            this.getMap().addLayer(this.directFeatureLayer);
        }

        // Bearbeitungslayer immer aktiv
        if (this.trackingLayer) {
            this.getMap().addLayer(this.trackingLayer);
        }

        return this;
    }


    /**
     *
     * @param {number}  startzoom  Initiale Zoomtiefe
     * @param {boolean} forceStartZoom Default-Wert = false, erzwingt die Nutzerung des Startzoom's
     * @param {number}  fit_zoom    Maximale Zoomtiefe für automatischen Zooming durch die fit-Methode
     */
    public renderMap(startzoom: number, forceStartZoom: boolean = false, fit_zoom: number = 0) {

        if (startzoom <= 0) {
            startzoom = this.defaultValues.maxZoom;
        }

        if (fit_zoom <= 0) {
            fit_zoom = this.defaultValues.maxZoom;
        }

        // Hintergrund-Layer einbinden -------------------------------------------------------------
        if (this.backgroundLayerExt) {
            let basegroup = new this.ol.layer.Group({
                title: 'Hintergrundkarten',
                idname: 'basis_map',

                // --- LayerSwitcher-Optionen
                allwaysOnTop:false,         // ist nicht "Immer oben"
                noSwitcherDelete:true,      // Kann nicht gelöscht werden
                // --------------------------

                layers: this.backgroundLayerExt.reverse()
            });
            this.map.addLayer(basegroup);
        }

        // WMS Layer einbinden ----------------------------------------------------------------------
        if (this.wmsLayerGroup && this.wmsLayerGroup.length) {
            for (let group of this.wmsLayerGroup.reverse()) {
                this.map.addLayer(group);
            }
        }


        let layerExtents = [];

        // Wenn DirectFeatures gesetzt wurden, dann Feature-Layer anzeigen (pos=1 bedeutet, VOR den Featurelayer)
        if (this.directFeatureLayer && this.directFeatureCounter && this.directFeatureLayer.get('pos')) {
            this.map.addLayer(this.directFeatureLayer);

            layerExtents.push(this.directFeatureLayer.getSource().getExtent());
        }

        // Wenn Features gesetzt wurden, dann Feature-Layer anzeigen
        if (this.featureLayer && this.featureCounter) {

            // Es kann mehr als einen FeatureLayer geben
            if (this.additionalFeatureLayer) {
                for (let j = this.additionalFeatureLayer.length; j > 0; j--) {
                    this.map.addLayer(this.additionalFeatureLayer[j - 1]);

                    layerExtents.push(this.additionalFeatureLayer[j - 1].getSource().getExtent());
                }
            }

            // Der Hauptlayer kommt über die zusätzlichen Layer
            this.map.addLayer(this.featureLayer);
            layerExtents.push(this.featureLayer.getSource().getExtent());
        }

        // Wenn DirectFeatures gesetzt wurden, dann Feature-Layer anzeigen (pos=0 bedeutet, NACH den Featurelayer)
        if (this.directFeatureLayer && this.directFeatureCounter && !this.directFeatureLayer.get('pos')) {
            this.map.addLayer(this.directFeatureLayer);
            layerExtents.push(this.directFeatureLayer.getSource().getExtent());
        }

        // Graticule-Layer anzeigen
        if (this.graticuleLayer) {
            this.map.addLayer(this.graticuleLayer);
        }

        // Overlay-Layer anzeigen
        if (this.overlayLayer) {
            this.map.addOverlay(this.overlayLayer);
        }

        // Controls auf die Karte setzen
        for (let i = 0; i < this.mapControls.length; i++) {
            this.map.addControl(this.mapControls[i]);
        }

        // Interaktionen zur Karte hinzufügen
        for (let i = 0; i < this.mapInteractions.length; i++) {
            this.map.addInteraction(this.mapInteractions[i]);
        }

        // Startansichten (Mittelpunkt und Zoomtiefe) festlegen/interpretieren
        /*
            1. Es kann eine Startansicht erzwungen werden, egal ob Features bereitstehen oder nicht
            2. Die Startansicht nicht erzwungen werden soll:
                2.a. Liegen keine Feature vor, dann Starteinstellungen nutzen
                2.b. Liegt ein Feature vor, Feature zentrieren und Zoom bis maximal Start oder FitZoom
                2.c. Zentrum ermitteln und maximal bis FitZoom hineinzoomen

         */

        let currentExtent =  this.getExtent(layerExtents);

        this.debug('---- layerExtents');
        this.debug(layerExtents);
        this.debug('---- currentExtent');
        this.debug(currentExtent);


        if (currentExtent.length)
        {
            this.map.getView().fit(currentExtent, {
                maxZoom: fit_zoom,
                duration: this.defaultValues.duration
            });
        }
        else
        {
            this.debug('startzoom= ' + startzoom);
            this.map.getView().setZoom(startzoom);
        }



        /*
        let featureCounter: any = this.featureCounter + this.directFeatureCounter;

        this.debug('featureCounter: ' + featureCounter);
        this.debug('forceStartZoom: ' + forceStartZoom);
        if (nextent && featureCounter > 0 ) {
            if (featureCounter > 1 && !forceStartZoom) {
                this.debug('fit_zoom= ' + fit_zoom);
                this.map.getView().fit(nextent, {
                    maxZoom: fit_zoom,
                    duration: this.defaultValues.duration
                });
            }
            else
            {
                this.debug('startzoom= ' + startzoom);
                this.debug('fit_zoom= ' + fit_zoom);
                this.debug('firstPoint= ' + this.firstPoint.toString());
                if (forceStartZoom)
                {
                    this.debug('mit startzoom: ' + startzoom);
                    this.map.getView().setCenter(this.firstPoint);
                    this.map.getView().setZoom(startzoom);
                }
                else
                {
                    this.debug('mit fit_zoom: ' + fit_zoom);
                    this.map.getView().setCenter(this.firstPoint);
                    this.map.getView().setZoom(fit_zoom);
                }

            }
        } else {
            this.debug('startzoom= ' + startzoom);
            this.map.getView().setZoom(startzoom);
        }

         //*/

        // Prüfung, ob Layer mit abrufbaren FeatureInfo's angezeigt werden, aktivieren
        this.defaultOnPointermove();

        //return this;
    }


    /**
     * Aktualisiert die Karten bzgl. der Features auf dem Trackinglayer.
     */
    public redrawExtent()
    {
        let cMap = this.getMap();
        let tLyr = this.getTrackingLayer().getSource();

        let view = cMap.getView();
        let resolution = view.getResolutionForExtent(tLyr.getExtent(), cMap.getSize());
        let zoom = resolution ? parseInt(view.getZoomForResolution(resolution))  : 15;
        let center = this.ol.extent.getCenter(tLyr.getExtent());
        view.setCenter(center);
        view.setZoom(zoom);
    }

    /**
     *
     * @protected
     */
    protected getExtent(layerExtents:any[]) {
        // Extent-Control ggf. setzen (10% in Breite und Höhe hinzunehmen)
        let extent: any = null;

        if (this.trackingLayer) {
            extent = this.trackingLayer.getSource().getExtent();
            if (extent[0] == "Infinity")
            {
                extent = null;
            }
        }

        let controls = this.getMap().getControls();
        for (let i = 0; i < controls.getLength(); i++) {
            if (this.isEditable() && controls.item(i) instanceof this.ol.control.ZoomToExtent) {
                this.ZoomToExtentCtrl = controls.item(i);
            } else if (controls.item(i) instanceof this.ol.control.ZoomToExtent) {
                this.getMap().removeControl(controls.item(i));
            }
        }


        let nextent = [];
        if (this.ZoomToExtentCtrl && extent) {
            let padding = this.defaultValues.extentPaddingFactor;

            let paddingx = (padding * (Math.abs(extent[2] - extent[0]))) / 100;
            let paddingy = (padding * (Math.abs(extent[3] - extent[1]))) / 100;

            nextent[0] = extent[0] - paddingx;
            nextent[1] = extent[1] - paddingy;
            nextent[2] = extent[2] + paddingx;
            nextent[3] = extent[3] + paddingy;

            this.ZoomToExtentCtrl.extent = nextent;
        }

        this.setZoomToExtentState();
        return nextent;
    }

    /**
     *
     */
    public setZoomToExtentState()
    {
        if (this.ZoomToExtentCtrl) {
            let element = this.ZoomToExtentCtrl.element;
            let children: HTMLCollection = null;
            let button: any = null;

            if (element) {
                children = element.children;
                // console.log(children);

                for (let i = 0; i < children.length; i++) {
                    //console.log(children.item(i).tagName);
                    if (children.item(i).tagName.toLowerCase() == 'button') {
                        button = children.item(i);
                        break;
                    }
                }
            }

            if (button) {
                if (this.countFeatures() > 0) {
                    button.disabled = false;
                } else {
                    button.disabled = true;
                }
            }
        }
    }

    /**
     *
     */
    public initTrackingLayer(title?: string) {
        let instance = this;
        let source = new this.ol.source.Vector({});
        title = title ? title : 'Eingabe-Layer';
        this.trackingLayer = new this.ol.layer.Vector({
            idname: 'trackingLayer',
            title: title,
            info_type: 'html',
            info_id: 'featureTracking_info',
            show_info: 0,
            opacity: instance.getTrackinglayerStyle().getOpacity(),

            // --- LayerSwitcher-Optionen
            allwaysOnTop: true,      // Immer Oben
            noSwitcherDelete: true,  // Kann nicht gelöscht werden
            // --------------------------

            updateWhileInteracting: true,

            source: source,
            style: function (feature) {
                let type = feature.get('type');
                let geometry_type = feature.get('geometry_type');
                let s: any = null;
                if (type || geometry_type) {
                    s = instance.getPointStyle(type, geometry_type);
                }
                if (!s) {
                    return instance.getTrackinglayerStyle().create(instance.ol);
                }

                return s;
            }
        });

        return this;
    }

    public activateEditBar(_interactions: any = {}) {
        this.editbar = new GCPortalkarteEditbarClass(this,this.getTrackingLayer());
        if (this.editbar)
        {
            this.editbar.activateEditBar(_interactions);
        }
    }

    private openEditDialog()
    {
        let instance = this;
        let modul   = instance.jquery('#'+instance.getTargetId());
        let url     = instance.getInfoUrl();
        url         = url.replace('_INFO_ID_', '').replace('_INFO_TYPE_', 'dialog');
        url         = url + '&show=editmeta';

        let options = {
            title: 'Bearbeiten',
            footer: false,
            ajaxUrl: '',
            source_id: 'feature_edit_meta',
            options: {
                append: modul,
                description: {
                    close: {
                        caption: "Schließen"
                    }
                }
            }
        }
        // console.log(options);
        // @ts-ignore
        BtpDialogClass.invokeDirect(options);
    }





    /**
     * Gib die Referenz auf den Trackinlayer zurück
     */
    public getTrackingLayer() {
        return this.trackingLayer;
    }


    /**
     * Zugriff auf den aktellen Layer für dynamische Daten
     */
    public getCurrentLayer()
    {
        return this.trackingLayer;
    }


    /**
     * Setzt den Selector für das Element, in dem der GeoJSON gespeichert wird
     * @param {string} target
     */
    public setGeoJsonTarget(target: string) {
        this.geoJsonTarget = target;
        return this;
    }

    /**
     * aktiviert/deaktiviert Editierbarkeit
     * @param value
     */
    public setIsEditable(value: boolean) {
        this.is_editable = value;

        return this;
    }

    /**
     * Gibt zurück, ob editierbar oder nicht
     */
    public isEditable() {
        return this.is_editable;
    }

    /**
     * aktiviert/deaktiviert Editierbarkeit der Metadaten (z.B. Titel)
     * @param value
     */
    public setIsEditMeta(value: boolean) {
        this.is_edit_meta = value;

        return this;
    }

    /**
     * Gibt zurück, ob Metadaten editierbar oder nicht
     */
    public isEditMeta() {
        return this.is_edit_meta;
    }

    /**
     * Gibt die Reference auf das EditBar-Objekt zurück (liegt in der Menübar)
     */
    public getEditBar() {
        return this.editbar;
    }

    /**
     * Erzeugt eine Eingabe für den Titel eine Geo-Features
     * @param e
     * @param type
     * @param title
     * @param index
     * @private
     */
    public static createFeatureMetadata(e, type, title, index) {
        let nTitel = prompt("Bitte einen Titel eingeben", title + ' ' + index);
        if (!nTitel) {
            nTitel = title + ' ' + index;
        }
        e.feature.set('idname', 'nf_' + index);
        e.feature.set('title', nTitel);
    }




    /**
     * Speichert die Daten des Trackinglayers als GeoJSON in einem DOM-Objekt
     * @private
     */
    public saveData(instance?: any) {
        if (typeof instance === "undefined") {
            instance = this;
        }
        let target = instance.geoJsonTarget;
        let trackingSource = instance.trackingLayer.getSource();
        let json = new instance.ol.format.GeoJSON().writeFeatures(trackingSource.getFeatures());

        if (target) {
            let targetElement = document.getElementById(target.replace('#', ''));
            if (targetElement) {
                // @ts-ignore
                targetElement.value = json || "";
            }
        }

        if (trackingSource) {
            let extent = trackingSource.getExtent();
            if (instance.ZoomToExtentCtrl) {
                instance.ZoomToExtentCtrl.extent = extent;
                instance.setZoomToExtentState();
            }
        }

    }

    /**
     * Ermittelt den Anzeigestatus der Karte (Centerpoint, Zoomtiefe und aktuelles Koordinatensystem)
     */
    public getStatus(projection = 'EPSG:4326') {
        let view = this.getMap().getView();
        let center = view.getCenter();
        let crs = view.getProjection().getCode();

        if (crs !== projection)
        {
            center  = this.ol.proj.transform(center, crs, projection);
            crs     = projection;
        }

        let result: object = {
            zoom: view.getZoom(),
            center_x: Math.round(center[0] * 10000000.0) / 10000000.0,
            center_y: Math.round(center[1] * 10000000.0) / 10000000.0,
            crs: crs
        }

        return result;
    }

    /**
     * Liefert die aktuelle Anzahl an Features im Trackinglayer
     */
    public countFeatures() {
        return this.trackingLayer.getSource().getFeatures().length;
    }

    /**
     * Setzt das Limit an möglichen Features (0 = unendlich)
     * @param {number} max
     */
    public setMaxFeatures(max: number) {
        this.maxFeatures = max;
        return this;
    }

    /**
     * Liefert das Limit an möglichen Features
     */
    public getMaxFeatures() {
        return this.maxFeatures ? Math.abs(this.maxFeatures) : 0;
    }

    /**
     *
     * @param opacity
     * @param fill_color
     * @param stroke_color
     * @param stroke_width
     * @param radius
     */
    public setTrackinglayerFeatureStyles(opacity:number, fill_color:string, stroke_color:string, stroke_width:number, radius?:number)
    {
        this.getTrackinglayerStyle().setOpacity(opacity);
        this.getTrackinglayerStyle().setFillColor(fill_color);
        this.getTrackinglayerStyle().setStrokeColor(stroke_color);
        this.getTrackinglayerStyle().setStrokeWidth(stroke_width);
        if (radius)
        {
            this.getTrackinglayerStyle().setRadius(radius);
        }
        else
        {
            this.getTrackinglayerStyle().setRadius(stroke_width + 5);
        }

        return this;
    }

    /**
     *
     */
    public isAddFeaturePossible()
    {
        if (this.getMaxFeatures() > 0) {
            if (this.countFeatures() >= this.getMaxFeatures()) {
                return false;
            }
        }
        return true;
    }

    /**
     *
     */
    public getTrackinglayerStyle()
    {
        return this.trackinglayer_style;
    }

    /**
     *
     * @param style
     */
    public setTrackinglayerStyle(style:GCPortalkarteStyle)
    {
        this.trackinglayer_style = style;
        return this;
    }
}